import { DeskDrawerToSimpleSapElementMapper } from '../desk/deskDrawerToSimpleSapElementMapper';

export class DressingDrawerToSimpleSapElementMapper
    extends DeskDrawerToSimpleSapElementMapper {

}